// @core/api/endpoints/platform/get_federation_health_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFederationHealthHistoryResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get federation health history
 * Returns the health check history for a federation peer over a specified time range.
 */
export async function GetFederationHealthHistory(
  peer_id: string,
  options?: RequestOptions
): Promise<GetFederationHealthHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id/health/history`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.get<GetFederationHealthHistoryResponse>(requestPath, { ...requestOptions });
}
